import { Routes } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { unAuthGuard } from './unauth.guard';
import { authGuard } from './auth.guard';
import { CategoriesPageComponent } from '../categories/categories-page/categories-page.component';

import { gettingStartedGuard } from './getting-started.guard';
import { upgradeGuard } from './upgrade.guard';
import { adminGuard } from './admin.guard';
import { resubscribeGuard } from './resubscribe.guard';
import { featureFlagGuard } from './feature-flag.guard';

export const routes: Routes = [
  {
    path: 'billing/handoff',
    data: { hideTopBar: true },
    loadComponent: () =>
      import('../billing-handoff/billing-handoff.component').then(m => m.BillingHandoffComponent),
  },
  {
    path: '',
    redirectTo: '/budgets',
    pathMatch: 'full',
  },
  {
    path: 'budgets',
    component: CategoriesPageComponent,
    canActivate: [gettingStartedGuard, upgradeGuard],
    data: {
      showTopBar: true,
    },
    pathMatch: 'full',
  },
  {
    path: 'transactions',
    canActivate: [upgradeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../transactions/transactions.routes').then(m => m.routes),
  },
  {
    path: 'recurring-transactions',
    canActivate: [upgradeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../recurring-transactions/recurring-transactions.routes').then(m => m.routes),
  },
  {
    path: 'transaction-rules',
    canActivate: [upgradeGuard, featureFlagGuard('transaction-rules')],
    data: {
      goBackTo: '/transactions',
    },
    loadChildren: () => import('../transaction-rules/transaction-rules.routes').then(m => m.routes),
  },
  {
    path: 'reports',
    canActivate: [upgradeGuard, featureFlagGuard('reports')],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../reports/reports.routes').then(m => m.routes),
  },
  {
    path: 'accounts',
    canActivate: [upgradeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../accounts/accounts.routes').then(m => m.routes),
  },
  {
    path: 'account',
    canActivate: [upgradeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../user-account/user-account.routes').then(m => m.routes),
  },
  {
    path: 'upgrade',
    canActivate: [upgradeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../upgrade/upgrade.routes').then(m => m.routes),
  },
  {
    path: 'resubscribe',
    canActivate: [resubscribeGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../resubscribe/resubscribe.routes').then(m => m.routes),
  },
  {
    path: 'getting-started',
    canActivate: [authGuard],
    data: {
      goBackTo: '/budgets',
      hideTopBar: true,
    },
    loadChildren: () => import('../getting-started/getting-started.routes').then(m => m.routes),
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    canActivate: [unAuthGuard],
    data: { hideTopBar: true },
  },
  {
    path: 'login',
    data: { hideTopBar: true },
    loadChildren: () => import('../login/login.routes').then(m => m.routes),
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    data: {
      goBackTo: '/budgets',
    },
    loadChildren: () => import('../admin/admin.routes').then(m => m.routes),
  },
  { path: '**', redirectTo: '/budgets' },
];
